import { Markdown } from 'components';
import { AppContext } from 'providers/AppContext';
import { useContext } from 'react';

export function RiskqLegend({ page }: Readonly<{ page: string }>) {
	const { t } = useContext(AppContext);

	if ('appropriateness_2' === page || 'appropriateness_3' === page) {
		return (
			<div className="arionui mb-5">
				<Markdown>{t(`${page}_legend`, 'testRisk')}</Markdown>
			</div>
		);
	}

	return null;
}
